export async function initialAndSearchStateSetter(searchedKeyword, searchedDataOfContact, navigate, setIsLoading, setTheData, allDataOfContact) {
    if(searchedKeyword) {
        if(Object.keys(searchedDataOfContact).length == 0) {
          navigate(`/Search/${searchedKeyword}`);
        }
        if((searchedDataOfContact) && (searchedDataOfContact.success)) {
          setIsLoading(false);
          setTheData(searchedDataOfContact)  
        }
      } else {
        if((allDataOfContact) && (allDataOfContact.success)) {
          setIsLoading(false);
          setTheData(allDataOfContact)
        }
      }
      
}